import client from '../client'

export async function verifyAccount() {
  return client(`${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/Verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  })
}
